import { Typography } from "@mui/material";

export default function TitlePages({children, ...props}){
    return (
        <Typography sx={{fontWeight: 'bold', fontSize: '1.5rem'}} {...props}>
            {children}
        </Typography>
    )
}